import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Why NextJS /api routes are fab – CodeWithSwiz 6",
  "description": "In this episode of CodeWithSwiz, we tried NextJS's support for /api routes – code running on the backend. In a word – Wow",
  "published": "2020-09-13T00:00:00.000Z",
  "categories": "CodeWithSwiz, Technical, NextJS, Livecoding",
  "hero": "./img/screenshot-1600041512681.png"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`NextJS has built-in support for backend code and wow`}</p>
    <p><em parentName="p">{`CodeWithSwiz is a twice-a-week live show. Like a podcast with video and fun hacking. Focused on experiments. `}<a parentName="em" {...{
          "href": "https://youtube.com/swizecteller"
        }}>{`Join live Wednesdays and Sundays`}</a></em></p>
    <lite-youtube {...{
      "videoid": "zjGTC9PK2gA",
      "videostartat": "0"
    }}></lite-youtube>
    <p>{`In this episode of CodeWithSwiz, we tried NextJS's support for /api routes – code running on the backend.`}</p>
    <p>{`Got that working, then my internet died. Couldn't finish the full objective of using an /api route to publish code to GitHub. 💩`}</p>
    <h2 {...{
      "id": "why-nextjs-api-routes-are-great"
    }}>{`Why NextJS /api routes are great`}</h2>
    <p>{`NextJS uses a special `}<inlineCode parentName="p">{`/pages/api`}</inlineCode>{` folder for routes running on the server. Both at compile-time `}<em parentName="p">{`and`}</em>{` run-time. Always server side code.`}</p>
    <p>{`Same file-based routing as your frontend code 👉 put a file there and it's available at `}<inlineCode parentName="p">{`<domain>/api/filename`}</inlineCode>{`. Export a default function from this file and that's your API controller.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`// pages/api/publishArticle.js

export default async (req, res) => {
  res.status(200).json({ success: true });
};
`}</code></pre>
    <p><inlineCode parentName="p">{`req`}</inlineCode>{` is the request object, `}<inlineCode parentName="p">{`res`}</inlineCode>{` is the response object. You read inputs from `}<inlineCode parentName="p">{`req`}</inlineCode>{` and return outputs by modifying `}<inlineCode parentName="p">{`res`}</inlineCode>{`.`}</p>
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "830px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/44f0bf1106c764dec1af1d88b4a29490/715a3/Testing-an-api-route-in-the-browsere3ac99.png",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "35.42600896860987%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'142\\'%20viewBox=\\'0%200%20400%20142\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M109%2022c0%207%201%208%203%206h4c3%201%203%200%203-7v-4l-5-1h-5v6m39-4c-3%203-2%207%201%209%205%204%2012-3%208-8-2-3-6-4-9-1\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/44f0bf1106c764dec1af1d88b4a29490/ca0a1/Testing-an-api-route-in-the-browsere3ac99.webp 223w", "/static/44f0bf1106c764dec1af1d88b4a29490/75680/Testing-an-api-route-in-the-browsere3ac99.webp 445w", "/static/44f0bf1106c764dec1af1d88b4a29490/b2a51/Testing-an-api-route-in-the-browsere3ac99.webp 830w"],
                "sizes": "(max-width: 830px) 100vw, 830px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/44f0bf1106c764dec1af1d88b4a29490/e92b6/Testing-an-api-route-in-the-browsere3ac99.png 223w", "/static/44f0bf1106c764dec1af1d88b4a29490/e66bf/Testing-an-api-route-in-the-browsere3ac99.png 445w", "/static/44f0bf1106c764dec1af1d88b4a29490/715a3/Testing-an-api-route-in-the-browsere3ac99.png 830w"],
                "sizes": "(max-width: 830px) 100vw, 830px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/44f0bf1106c764dec1af1d88b4a29490/715a3/Testing-an-api-route-in-the-browsere3ac99.png",
                "alt": "Testing an /api route in the browser",
                "title": "Testing an /api route in the browser",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`Testing an /api route in the browser`}</figcaption>{`
  `}</figure></p>
    <p>{`You'll be familiar with this pattern, if you've used `}<a parentName="p" {...{
        "href": "https://expressjs.com/"
      }}>{`Express`}</a>{` before. The most popular JavaScript backend framework, I believe.`}</p>
    <p>{`Looks compatible with existing Express middlewares 🤘`}</p>
    <p>{`Locally these routes work with your development server. Deploy to Vercel and they become cloud functions. AWS Lambdas (I assume) running on each API call. Haven't tried with Netlify.`}</p>
    <p>{`In short, you get serverless without the pain 😍`}</p>
    <p><video parentName="p" {...{
        "style": {
          "margin": "auto auto",
          "display": "block",
          "maxWidth": "80%"
        },
        "autoPlay": true,
        "loop": true,
        "muted": true,
        "playsInline": true,
        "loading": "lazy"
      }}>{`
            `}<source parentName="video" {...{
          "src": "https://media2.giphy.com/media/8P7y2ARUPFpNaaWEZ3/giphy-loop.mp4?cid=7cf28b0fmwj253y61r0w4w4tul3c7je4dicpzr3c2ur0kgyk&rid=giphy-loop.mp4&ct=g",
          "type": "video/mp4"
        }}></source>{`
        `}</video></p>
    <h2 {...{
      "id": "how-you-can-use-api-to-get-things-done"
    }}>{`How you can use /api to get things done`}</h2>
    <p>{`Unlike the traditional Express approach, NextJS forces you to use these routes as an API. They're meant to return data, not pages.`}</p>
    <p>{`You want to have this discipline in your project as early as possible. Transitioning later when your team grows hurts. Been working on that transition at dayjob.exe and oof, hella gotchas 😅`}</p>
    <p>{`On the stream, we created a `}<a parentName="p" {...{
        "href": "https://react-query.tanstack.com/"
      }}>{`React Query`}</a>{` mutation running off a button click. It sends a POST request to our `}<inlineCode parentName="p">{`/api`}</inlineCode>{` route with the full article.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`// components/ShipIt.js

export const ShipIt = ({ article }) => {
  const [shipArticle, { status, isLoading }] = useMutation(async () => {
    // makes a POST request to the server
    return fetch("/api/publishArticle", {
      method: "POST",
      headers: {
        // enables automatic body parsing
        "Content-Type": "application/json",
      },
      body: JSON.stringify(article),
    });
  });

  if (isLoading) {
    return <Spinner></Spinner>;
  } else {
    return <Button onClick={shipArticle}>Ship It</Button>;
  }
};
`}</code></pre>
    <p>{`We set up a mutation, show a spinner when it's loading, and a button with a click handler otherwise. Click the button, call the `}<inlineCode parentName="p">{`shipArticle`}</inlineCode>{` method returned from `}<inlineCode parentName="p">{`useMutation`}</inlineCode>{`, execute the `}<inlineCode parentName="p">{`fetch()`}</inlineCode>{` call.`}</p>
    <p>{`Setting the content-type header tells NextJS to parse POST body as a JSON string. Makes it easier to access values :)`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`// pages/api/publishArticle.js

export default async (req, res) => {
  // req.body.title == article title
  // req.body.description == article description
  // etc

  res.status(200).json({ success: true });
};
`}</code></pre>
    <p>{`Tanner says we can share queries and mutations between frontend and backend. Gonna try that next time ✌️`}</p>
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`Yes you can. `}<a parentName="p" {...{
          "href": "https://t.co/4LTsY4B4gw"
        }}>{`https://t.co/4LTsY4B4gw`}</a></p>{`— Tanner Linsley ⚛️ (@tannerlinsley) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/tannerlinsley/status/1305266028574728192"
      }}>{`September 13, 2020`}</a></blockquote>
    <h2 {...{
      "id": "using-githubs-rest-api-to-commit-files"
    }}>{`Using GitHub's REST API to commit files`}</h2>
    <p>{`Original goal was to use an `}<inlineCode parentName="p">{`/api`}</inlineCode>{` route to publish an article. Since they're markdown files in a repo, that means using the GitHub API to make a commit.`}</p>
    <p>{`We use the `}<a parentName="p" {...{
        "href": "https://github.com/octokit/rest.js/"
      }}>{`@octokit/rest`}</a>{` library for that.`}</p>
    <p>{`Runs in Node.js, which means it works with our NextJS server routes. But it's super complex and hard to figure out.`}</p>
    <p>{`After much spelunking through the docs, we got an authenticated request working. It required a `}<a parentName="p" {...{
        "href": "https://docs.github.com/en/github/authenticating-to-github/creating-a-personal-access-token"
      }}>{`personal GitHub acces token`}</a>{` added to `}<inlineCode parentName="p">{`.env.local`}</inlineCode>{`.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`// pages/api/publishArticle.js

import { Octokit } from "@octokit/rest";

const octokit = new Octokit({
  auth: process.env.GITHUB_TOKEN,
});

export default async (req, res) => {
  const { data } = await octokit.request("/user");
  // prints user info
  console.log(data);

  // ...
};
`}</code></pre>
    <p>{`Instantiates Octokit with your token and requests `}<inlineCode parentName="p">{`/user`}</inlineCode>{` data. Makes the project hardcoded to you, but works. We'd have to add a full authentication system to let anyone else use this.`}</p>
    <p>{`We figured out how to add files to repositories juuuuust as my internet died.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`await octokit.repos.createOrUpdateFileContents;
`}</code></pre>
    <p>{`Join me Wednesday evening and we'll figure out the rest 🤞`}</p>
    <p>{`Cheers,`}<br />{`
~Swizec`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      